import axios from 'axios';

export const state = () => ({
    terms: []
});

export const getters = {
    terms: state => state.terms
};

export const mutations = {
    SET_ITEMS(state, terms) {
        state.terms = terms;
    }
};

export const actions = {
    async index({ commit }, { businessProfileId }) {
        const data = await axios.$get(`/v1/sentiments/exclude_words?business_profile_id=${businessProfileId}`);
        commit('SET_ITEMS', data);
    },

    create(vuexContext, { payload }) {
        return axios.$post('/v1/sentiments/exclude_words', { ...payload, ignoreSnakeCaseFormatting: true });
    },

    update(vuexContext, { id, payload }) {
        return axios.$put(`/v1/sentiments/exclude_words/${id}`, { ...payload, ignoreSnakeCaseFormatting: true });
    },

    delete(vuexContext, id) {
        return axios.$delete(`/v1/sentiments/exclude_words/${id}`);
    },

    setItems({ commit }, terms) {
        commit('SET_ITEMS', terms);
    }
};
